import styled, { css } from 'styled-components'

const Container = styled.span`
  list-style: none;
  align-items: center;
  width: 0;
  height: 0;
  overflow: hidden;
  transition: 0.225s ease-in;
  transition-property: width, height, opacity;

  ${props =>
    props.show &&
    css`
      height: 36px;
      width: 20ex;
      opacity: 1;
      display: flex;
    `}
`

// eslint-disable-next-line import/prefer-default-export
export { Container }
